import { alarmStateSchema } from '@sophocles/entities/AlarmState';
import { cameraInterfaceControllerSchema } from '@sophocles/entities/CameraInterfaceController';
import { siteConfigurationSchema } from '@sophocles/entities/SiteConfiguration';
import { siteMaintenanceLogSchema } from '@sophocles/entities/SiteMaintenanceLog';
import { siteWeatherConfigurationSchema } from '@sophocles/entities/SiteWeatherConfiguration';
import { smartlinkUnitSchema } from '@sophocles/entities/SmartlinkUnit';
import { Record } from 'immutable';
import { schema } from 'normalizr';

export const Site = new Record({
  id: undefined,
  name: '',
  description: '',
  deactivated: false,
  association: {
    customer: null,
    site_group: null,
  },
  time_zone: 'America/Chicago',
  relay_controller: null,
  latitude: undefined,
  longitude: undefined,
  location_description: '',
  site_groups: [],
  alarm_states: [],
  maintenance_logs: [],
  configuration: null,
  custom_data: {},
  status: null,
  cic: null,
  reporting_excessive_alarms: false,
  has_paired_relays: false,
  next_sunset: null,
  next_sunrise: null,
  weather_configuration: null,
});

export const siteSchema = new schema.Entity('sites', {
  relay_controller: smartlinkUnitSchema,
  cic: cameraInterfaceControllerSchema,
  configuration: siteConfigurationSchema,
  weather_configuration: siteWeatherConfigurationSchema,
  alarm_states: [alarmStateSchema],
  maintenance_logs: [siteMaintenanceLogSchema],
});
